<template>
  <div class="sidebar sidebar-mypage">
    <div class="sidebar-wrapper">
      <ul class="block block-menu">
        <li class="block-menu__item">
          <router-link to="/customer/my-page">会員情報</router-link>
        </li>
        <li class="block-menu__item">
          <router-link to="/customer/order/list">注文履歴</router-link>
        </li>
        <li class="block-menu__item">
          <router-link to="/customer/my-page/favourite">マイリスト</router-link>
        </li>
        <li class="block-menu__item">
          <router-link to="/customer/my-page/recommend">おすすめリスト</router-link>
        </li>
        <li class="block-menu__item">
          <router-link to="/customer/my-page/detail">ショップからの評価</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" src="../sidebar.scss" scoped>
</style>

<script>
export default {
  name: 'SidebarMyPage',
  data() {
    return {};
  }
};
</script>
